import { render, staticRenderFns } from "./startNumberGeneration.vue?vue&type=template&id=23aab2d6&scoped=true&"
import script from "./startNumberGeneration.vue?vue&type=script&lang=js&"
export * from "./startNumberGeneration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aab2d6",
  null
  
)

export default component.exports